module.exports = __webpack_public_path__ + "static/media/bg_opv.07977f3a.png";